import Main from '@/views/administracion/auditorias/Main.vue';
import Default from '@/views/administracion/auditorias/Default.vue';
import MainAuditoria from '@/views/administracion/auditorias/auditoria/Main.vue';
import DefaultAuditoriaInformes from '@/views/administracion/auditorias/auditoria/informes/Default.vue';
import MainInforme from '@/views/administracion/auditorias/auditoria/informes/informe/Main.vue';
import MainObservaciones from '@/views/administracion/auditorias/auditoria/informes/observaciones/Main.vue';
import MainRespuestas from '@/views/administracion/auditorias/auditoria/informes/respuestas/Main.vue';
import DefaultTablero from '@/views/administracion/auditorias/tablero/Default.vue';
import PrincipalSeguimiento from '../../../views/administracion/auditorias/seguimiento/Principal.vue';

const auth = ['Auditorías:ver'];
const scopes = ['Auditorías:ver', 'Auditorías:crear', 'Auditorías:editar', 'Auditorías:eliminar', 'Auditorías:registro'];

const auditorias = [
  {
    path: 'auditorias',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'auditorias',
        path: '/',
        meta: {
          title: 'Auditorias',
          auth,
          scopes,
        },
        component: Default,
      },
      {
        name: 'auditoriasTablero',
        path: 'tablero',
        meta: {
          title: 'Tablero',
          auth,
          scopes,
        },
        component: DefaultTablero,
        children: [],
      },
      {
        name: 'auditoriasSeguimiento',
        path: 'seguimiento',
        meta: {
          title: 'Seguimiento',
          auth,
          scopes,
        },
        component: PrincipalSeguimiento,
      },
      {
        path: ':idAuditoria',
        meta: {
          title: 'Auditoria',
          auth,
          scopes,
        },
        component: MainAuditoria,
        children: [
          {
            name: 'auditoriaInformes',
            path: 'informes',
            meta: {
              title: 'Auditorías informes',
              auth,
              scopes,
            },
            component: DefaultAuditoriaInformes,
          },
          {
            name: 'auditoriaInforme',
            path: 'informes/:idInforme/',
            meta: {
              title: 'Auditoría Informe',
              auth,
              scopes,
            },
            component: MainInforme,
            children: [
              {
                name: 'auditoriaInformeObservaciones',
                path: 'observaciones',
                meta: {
                  title: 'Auditoría Informe Observaciones',
                  auth,
                  scopes,
                },
                component: MainObservaciones,
              },
              {
                name: 'auditoriaInformeRespuestas',
                path: 'respuestas',
                meta: {
                  title: 'Auditoría Informe Respuestas',
                  auth,
                  scopes,
                },
                component: MainRespuestas,
              },
            ],
          },
        ],
      },

    ],
  },
];

export default auditorias;
